import { AppRegistry } from "react-native";
import App from "components/src/App.web";
import * as serviceWorker from './serviceWorker';
import swConfig from './swConfig';
AppRegistry.registerComponent("myprojectname", () => App);
AppRegistry.runApplication("myprojectname", {
    rootTag: document.getElementById("root"),
});
serviceWorker.register(swConfig);
